"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactDom = require("react-dom");

var _reactRemoveScroll = require("react-remove-scroll");

var _reactI18next = require("react-i18next");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _uuid = require("uuid");

var _useDialogHelpers2 = _interopRequireDefault(require("../../hooks/useDialogHelpers"));

require("./style.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

var Dialog = function Dialog(props) {
  var id = props.id,
      title = props.title,
      children = props.children,
      isOpen = props.isOpen,
      closeFunction = props.closeFunction,
      showCloseButton = props.showCloseButton,
      closeButtonText = props.closeButtonText,
      showCloseIcon = props.showCloseIcon,
      closeIcon = props.closeIcon,
      dialogLabel = props.dialogLabel,
      portalTarget = props.portalTarget,
      disableClosers = props.disableClosers;
  var wrapper = (0, _react.useRef)(null);

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  var _useDialogHelpers = (0, _useDialogHelpers2.default)({
    id: id,
    wrapperElement: wrapper,
    closeFunction: closeFunction,
    isOpen: isOpen,
    disableClosers: disableClosers
  }),
      labelId = _useDialogHelpers.labelId,
      dialogHelpersProps = _useDialogHelpers.dialogHelpersProps;

  if (!isOpen) return null;
  return /*#__PURE__*/(0, _reactDom.createPortal)( /*#__PURE__*/_react.default.createElement("div", {
    className: "Dialog"
  }, /*#__PURE__*/_react.default.createElement("div", _extends({
    className: "Dialog__wrapper"
  }, dialogHelpersProps, {
    ref: wrapper
  }), /*#__PURE__*/_react.default.createElement("div", {
    id: labelId,
    className: "Dialog__sr-only"
  }, dialogLabel), title && /*#__PURE__*/_react.default.createElement("div", {
    className: "Dialog__title"
  }, title()), showCloseIcon && /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    className: "Dialog__closeicon",
    "aria-label": t('general.close', 'Close'),
    onClick: closeFunction
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: "icon ".concat(closeIcon)
  })), /*#__PURE__*/_react.default.createElement(_reactRemoveScroll.RemoveScroll, {
    className: "Dialog__inner"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "Dialog__content"
  }, children), showCloseButton && /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    className: "Dialog__closebutton",
    onClick: closeFunction
  }, closeButtonText))), /*#__PURE__*/_react.default.createElement("div", {
    className: "Dialog__backdrop",
    "aria-label": t('general.close', 'Close')
  })), portalTarget);
};

Dialog.propTypes = {
  id: _propTypes.default.string,
  title: _propTypes.default.element,
  children: _propTypes.default.element.isRequired,
  isOpen: _propTypes.default.bool,
  closeFunction: _propTypes.default.func,
  showCloseButton: _propTypes.default.bool,
  closeButtonText: _propTypes.default.string,
  showCloseIcon: _propTypes.default.bool,
  closeIcon: _propTypes.default.string,
  dialogLabel: _propTypes.default.string,
  portalTarget: _propTypes.default.element,
  disableClosers: _propTypes.default.bool
};
Dialog.defaultProps = {
  id: (0, _uuid.v4)(),
  title: null,
  showCloseButton: false,
  closeButtonText: 'Close',
  showCloseIcon: false,
  closeIcon: 'icon-cross',
  dialogLabel: 'dialog',
  isOpen: false,
  closeFunction: null,
  portalTarget: typeof document !== 'undefined' ? document.body : null,
  disableClosers: false
};
var _default = Dialog;
exports.default = _default;